import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { PayrollType } from '../entities/payroll-type';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';

@Injectable()
export class PayrollTypeService extends BaseCrudService<PayrollType> {

  public uri = '/api/payrollType/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance PayrollTypeService');
  }

  buildSentence(entity?: PayrollType, event?: LazyLoadEvent): HttpParams {
    this.httpParams = new HttpParams();
    if (entity) {
      let query = ''; 
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.abbreviation ?
          `abbreviation${QueryOperator.Contain}${entity.abbreviation}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.mefClass ?
          `mefClass${QueryOperator.Contain}${entity.mefClass}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.mefType ?
          `mefType${QueryOperator.Contain}${entity.mefType}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isEmployerContribution ?
          `isEmployerContribution${QueryOperator.Equal}${entity.isEmployerContribution}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isZeroPayroll ?
          `isZeroPayroll${QueryOperator.Equal}${entity.isZeroPayroll}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isValid ?
          `isValid${QueryOperator.Equal}${entity.isValid}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCts ?
          `isCts${QueryOperator.Equal}${entity.isCts}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isApeRmv ?
          `isApeRmv${QueryOperator.Equal}${entity.isApeRmv}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/payroll-type.service.ts